export class mitID {
    constructor() {
        const apiBaseUrl = '/umbraco/api/mitIdApi/';

        this.statuses = Object.freeze({
            unset: -1,
            none: 0,
            requested: 1,
            verified: 2,
            exempted:3,
            error: 99
        });

        this.queryKeys = Object.freeze({
            code:'code',
            state:'state',
        });

        this.IsMitIDCallback = function(){
            const queryParameters = new URLSearchParams(window.location.search);
            return queryParameters.has(this.queryKeys.code) && queryParameters.has(this.queryKeys.state);
        }

        this.VerifyResponse = async function (code, state,callbackUrl) {
            try {
                const parameters = new URLSearchParams({
                    code: code,
                    state: state,
                    callbackUrl:callbackUrl
                });

                const response = await fetch(apiBaseUrl + 'VerifyResponse?' + parameters);
                const data = await response.json();

                if(data.HasError){
                    return data.Error;
                }
                
                return data.Response;

            } catch (error) {
                console.log(error);
                return null;
            }
        }

        this.GetAuthUri = async function (callbackUrl, requestAddressInfo = false, clientState = null) {

            try {
                const parameters = new URLSearchParams({
                    callbackUrl: callbackUrl,
                    requestAddressInfo: requestAddressInfo,
                    clientState: clientState
                });

                const response = await fetch(apiBaseUrl + 'GetAuthUri?' + parameters);
                const data = await response.json();
                return data.Response.uri;

            } catch (error) {
                console.log(error);
                return "";
            }
        }



        this.getCurrentUserStatus = async function () {
            const mitId = this;

            try {
                const response = await fetch(apiBaseUrl + 'GetCurrentUserStatus');

                const data = await response.json();

                return parseInt(data);

            } catch (error) {
                return mitId.statuses.error;

            }
        }
    }
};
export default new mitID();